import React from "react"
import SVG from "react-inlinesvg"
import { connect } from "react-redux"
import closeDark from "@images/icons/closeDark.svg"
import * as styles from "./SupplierSearchFiltersOverview.module.scss"

const SupplierSearchFiltersOverview = ({ staticData, updateResults, filters }) => {
  //consts
  const { categoryOptions, serviceOptions, subServiceOptions } = staticData

  const handleClearFilter = async ({ key, filter }) => {
    let newFilters = { ...filters }

    //handle removing item when filter is an array
    if (Array.isArray(newFilters[key])) {
      newFilters[key] = newFilters[key].filter((item) => item !== filter.value)
      if (!newFilters[key].length) {
        delete newFilters[key]
      }
    } else {
      delete newFilters[key]
    }

    updateResults(newFilters)
  }

  const selectedFilters = []
  const filterKeys = Object.keys(filters)

  for (let i = 0; i < filterKeys.length; i++) {
    let filterValue = filters[filterKeys[i]]

    switch (filterKeys[i]) {
      case "services":
        for (let j = 0; j < filterValue.length; j++) {
          selectedFilters.push({
            key: filterKeys[i],
            filter: serviceOptions.find((findValue) => findValue.value === filterValue[j]),
          })
        }
        break

      case "subservices":
        for (let j = 0; j < filterValue.length; j++) {
          selectedFilters.push({
            key: filterKeys[i],
            filter: subServiceOptions.find((findValue) => findValue.value === filterValue[j]),
          })
        }
        break

      case "category":
        let categoryFilterObject = categoryOptions.find(
          (findValue) => findValue.value === filterValue
        )
        selectedFilters.push({
          key: filterKeys[i],
          filter: categoryFilterObject,
        })
        break

      case "name":
        selectedFilters.push({
          key: filterKeys[i],
          filter: filterValue && { label: filterValue, value: "" },
        })
        break

      case "bundle":
        selectedFilters.push({
          key: filterKeys[i],
          filter: filterValue && { label: "Bundles", value: true },
        })
        break

      // case "style":
      //   for (let j = 0; j < filterValue.length; j++) {
      //     selectedFilters.push({
      //       key: filterKeys[i],
      //       filter: styleOptions.find(findValue => findValue.value === filterValue[j]),
      //     })
      //   }
      //   break
      //
      // case "pricerange":
      //   for (let j = 0; j < filterValue.length; j++) {
      //     selectedFilters.push({
      //       key: filterKeys[i],
      //       filter: priceOptions[NEXT_PUBLIC_ENV].find(
      //         findValue => findValue.value === filterValue[j]
      //       ),
      //     })
      //   }
      //   break

      default:
        break
    }
  }

  return (
    <div className={styles.SupplierSearchFiltersOverview}>
      <h2>{selectedFilters?.length ? "Your search" : "All suppliers"}</h2>
      {selectedFilters?.length ? (
        <ul className={styles.list}>
          {selectedFilters.map((item) =>
            item.filter ? (
              <li key={item.filter.label}>
                <button
                  className={styles.filterBtn}
                  type="button"
                  onClick={() => handleClearFilter(item)}
                >
                  <span>{item.filter.label}</span>
                  <SVG src={closeDark} width="10" />
                </button>
              </li>
            ) : null
          )}
          <li>
            <button className={styles.clearBtn} type="button" onClick={() => updateResults({})}>
              Clear all
            </button>
          </li>
        </ul>
      ) : null}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    staticData: state.staticData.data,
  }
}

export default connect(mapStateToProps)(SupplierSearchFiltersOverview)
